class DesignerSearch extends HTMLElement {
  connectedCallback() {
    this.searchInput = this.querySelector('input[name="search"]');
    this.items = Array.from(this.querySelectorAll('.designer-list__items'));
    this.alphabetSpans = Array.from(this.querySelectorAll('.designer-list__alphabets span'));
    this.sortSelect = this.querySelector('.designer-list__sort select');
    this.contentContainer = this.querySelector('.designer-list__content');
    this.countEl = this.querySelector('.designer-list__sort-by p');
    this.loader = this.querySelector('.designer-list__loading');
    this.emptyState = this.querySelector('.designer-list__empty');

    this.activeLetter = null;
    this.searchTimeout = null;
    this.sortItems('alphabetical');
    this.bindEvents();
    this.updateSortLabel();
    window.addEventListener('resize', () => this.updateSortLabel());
  }

  bindEvents() {
    if (this.searchInput) {
      this.searchInput.addEventListener('input', this.handleSearch.bind(this));
    }

    this.alphabetSpans.forEach((span) => {
      span.addEventListener('click', this.handleAlphabetClick.bind(this));
    });

    if (this.sortSelect) {
      this.sortSelect.addEventListener('change', this.handleSort.bind(this));
    }
  }


  sortItems(sortValue) {
  const sorted = [...this.items].sort((a, b) =>
    this.compareItems(a, b, sortValue)
  );

  sorted.forEach((item) => {
    this.contentContainer.appendChild(item);
  });

  this.updateCount(this.items.length);
}

  updateSortLabel() {
    if (!this.sortSelect) return;

    const alphabeticalOption = this.sortSelect.querySelector(
      'option[value="alphabetical"]'
    );

    if (!alphabeticalOption) return;

    alphabeticalOption.textContent =
      window.innerWidth <= 768 ? 'A-Z' : 'Alphabetical';
  }
showLoader() {
  this.loader?.classList.add('active');
  this.contentContainer?.classList.add('loading');
}

hideLoader() {
  this.loader?.classList.remove('active');
  this.contentContainer?.classList.remove('loading');
}


  // ---------- SEARCH ----------
  handleSearch(event) {
    // Debounce so we're not filtering on every single keystroke
    clearTimeout(this.searchTimeout);
    this.showLoader();
    const term = event.target.value.trim().toLowerCase();

    this.searchTimeout = setTimeout(() => {
      // Typing in search clears any active alphabet filter
      this.clearActiveLetter();
      this.filterItems((item) => {
        const title = (item.dataset.title || '').toLowerCase();
        return term === '' || title.includes(term);
      });
      this.hideLoader();
    }, 250);
  }

  // ---------- ALPHABET FILTER ----------
  handleAlphabetClick(event) {
    const letter = event.currentTarget.textContent.trim().toUpperCase();

    // Clear the search field per the requirement
    if (this.searchInput) this.searchInput.value = '';

    // Clicking the already-active letter again resets to show all
    if (this.activeLetter === letter) {
      this.clearActiveLetter();
      this.filterItems(() => true);
      return;
    }

    this.activeLetter = letter;
    this.alphabetSpans.forEach((span) => span.classList.remove('active'));
    event.currentTarget.classList.add('active');

    this.showLoader();

setTimeout(() => {
  this.filterItems((item) => {
    const startingLetter = (item.dataset.startingLetter || '').toUpperCase();
    return startingLetter === letter;
  });

  this.hideLoader();
}, 200);
  }

  clearActiveLetter() {
    this.activeLetter = null;
    this.alphabetSpans.forEach((span) => span.classList.remove('active'));
  }

  // ---------- SHARED FILTER LOGIC ----------
  filterItems(matchFn) {
    let visibleCount = 0;

    this.items.forEach((item) => {
      const isMatch = matchFn(item);
      item.style.display = isMatch ? '' : 'none';
      if (isMatch) visibleCount += 1;
    });
if (this.emptyState) {
    this.emptyState.hidden = visibleCount !== 0;
  }
    this.updateCount(visibleCount);
  }

  updateCount(count) {
    if (!this.countEl) return;
    this.countEl.textContent = `${count} Designer${count === 1 ? '' : 's'}`;
  }

  // ---------- SORT ----------
  handleSort(event) {
    const sortValue = event.target.value;
    const sorted = [...this.items].sort((a, b) => this.compareItems(a, b, sortValue));

    // Re-append in sorted order; this.items keeps its reference,
    // only the DOM order changes
    this.showLoader();

setTimeout(() => {
  sorted.forEach((item) => this.contentContainer.appendChild(item));
   this.sortItems(sortValue);
  this.hideLoader();
}, 200);
  }

  compareItems(a, b, sortValue) {
    if (sortValue === 'date-new' || sortValue === 'date-old') {
      const dateA = this.parseDate(a.dataset.date);
      const dateB = this.parseDate(b.dataset.date);
      return sortValue === 'date-new' ? dateB - dateA : dateA - dateB;
    }

    // Default / 'alphabetical'
    const titleA = (a.dataset.title || '').toLowerCase();
    const titleB = (b.dataset.title || '').toLowerCase();
    return titleA.localeCompare(titleB);
  }

  parseDate(value) {
    const timestamp = value ? new Date(value).getTime() : NaN;
    // Items without a valid date sink to the bottom regardless of direction
    return Number.isNaN(timestamp) ? -Infinity : timestamp;
  }
}

customElements.define('designer-search', DesignerSearch);